const locale = {
  dashboard: 'Deska rozdzielcza',
  home_dashboard: 'Dom',
  dashboard_news: 'Aktualności',
  dashboard_slides: 'Banery',
  dashboard_notifications: 'Powiadomienia',
  dashboard_account: 'Moje konto',
  dashboard_team: 'Mój zespół',
  dashboard_mini_site: 'Mini-strona',
  dashboard_loyalty_campaign: 'Kampania lojalnościowa',
  product_order: 'Zamów produkty',
  digital_pub: 'Reklama cyfrowa',
  training: 'Szkolenie',
  dashboard_content_library: 'Biblioteka treści',
  hairdressers_network: 'Sieć fryzjerskich',
  hairdressers: 'Fryzjerskie',
  hairdressers_list: 'Lista fryzjerskich',
  hairdresser_add: 'Dodaj fryzjerski',
  link_hairdresser_supervisor: 'Łączność z fryzjerskim/supervisor',
  services: 'Usługi',
  services_list: 'Wykaz usług',
  services_add: 'Dodaj usługę',
  services_link: 'Połączyć usługę',
  national_operations: 'Operacje krajowe',
  national_operations_list: 'Wykaz operacji krajowych',
  national_operations_add: 'Dodaj operację krajową',
  national_operations_participate: 'Powiązanie z operacją krajową',
  prices: 'Prestacje i stawki',
  jobs: 'Oferty pracy',
  jobs_list: 'Lista ofert pracy',
  jobs_add: 'Dodaj ofertę pracy',
  customer_relationship: 'Klient powiązany',
  contacts: 'Kontakty',
  contacts_list: 'Lista kontaktów',
  contacts_import: 'Kontakty importowe',
  origin_code_list: 'Wykaz kodów pochodzenia',
  origin_code_add: 'Dodaj kod pochodzenia',
  feedbacks: 'Opinie klientów',
  feedbacks_list: 'Lista opinii klientów',
  feedbacks_response_model: 'Szablon odpowiedzi',
  feedbacks_receiver: 'Odbiorcy powiadomień',
  access: 'Dostęp',
  collaborators: 'Lista współpracowników',
  collaborators_add: 'Dodaj współpracownika',
  users_and_groups: 'Użytkownicy i grupy',
  users_list: 'Lista użytkowników',
  users_add: 'Dodaj użytkownika',
  groups_list: 'Lista grup',
  groups_add: 'Dodaj grupę',
  resources: 'Źródła',
  press: 'Obszar prasowy',
  press_admin: 'Presse administracji',
  documentation: 'Dokumentacja',
  documentation_admin: 'Dokumentacja administracyjna',
  intranet_doc: 'Przestrzeń dokumentalna',
  mass_administration: 'Zarządzanie masą',
  minisite: 'Minisites',
  minisiteList: 'Monitorowanie aktualizacji',
  minisiteMessageList: 'Lista pozdrowień',
  minisiteTagList: 'lista metatagów',
  minisiteMassiveImport: 'Administracja zbiorcza',
  access_to: 'dostęp do',
  payment_x3: 'Płatność w 3 ratach',
  prices_list: 'Lista usług i cen',
  legals_list: 'Lista informacji prawnych',
  legals_add: 'Dodaj informację prawną',
  legals_participate: 'Powiąż informację prawną',
  mass_administration_price_list: 'Usługi i Ceny',
  mass_administration_businessHours_list: 'Godziny otwarcia',
  mass_administration_message_list: 'Wiadomości Powitalne',
  mass_administration_tag_list: 'Tagi Meta',
  mass_administration_picture_list: 'Zdjęcia',
  terms_nav: 'Regulamin',
  TOU: 'Regulamin korzystania',
  privacy_policy: 'Polityka prywatności',
  cookies_policy: 'Polityka zarządzania plikami cookies',
  faq: 'Najczęściej Zadawane Pytania'
};

export default locale;
